<div class="seperator"></div>
<div class="title" mat-dialog-title>Enable Adobe Search</div>
<div class="dialog-body">
    <div class="body-content">
        <div class="form-text">Please schedule a daily Adobe Search report and send to below email: </div>
        <div class="ias-email">
            {{asEmail}}
        </div>
        <!--  TODO: upload template for adobe search 
        <div class="template">
            You can click <a href="https://rubii-images.s3-ap-southeast-2.amazonaws.com/templates/as-template.xlsx"
                target="_blank">here</a> to download a sample report.
        </div> -->
    </div>
</div>
<div class="dialog-footer">
    <div>
    </div>
</div>